<template>
  <aside class="aside-top">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="breadCrumbItem in getBreadcrumb"
        :key="breadCrumbItem.name"
        :to="breadCrumbItem.path"
      >
        {{ breadCrumbItem.name }}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="nameMes">
      <span class="name sign-out" @click="signOutHandle">{{ name || "" }}</span>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from "vuex";
import { GetLoginInfo } from "@/service/api.js";
import { loginUrl } from "@/service/baseUrl";
export default {
  data() {
    return {
      isShowChangePassword: false,
      passwordForm: {
        oldpassword: "",
        newpassword: "",
        newpassword2: "",
      },
    };
  },
  computed: {
    ...mapGetters(["getBreadcrumb", "getLoginName"]),
    breadCrumbList() {
      return this.$route.matched;
    },
    name() {
      if (!this.getLoginName) {
        let localMes = this.$cache.get("searchOriginLoginMes");
        if (localMes) {
          let localMesObj = JSON.parse(localMes);

          if (localMesObj.user_info.jobs) {
            return localMesObj.user_info.jobs[0].name;
          } else {
            this.$cache.remove("searchOriginLoginMes", "");
          }
        }
        return "请退出重新登录";
      } else {
        return this.getLoginName;
      }
    },
  },

  methods: {
    signOutHandle() {
      this.$confirm(`确定退出吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$cache.remove("token");
          this.$cache.remove("searchOriginLoginMes");
          // 退出登录后跳转到auth页面，将当前路由名作为路径参数
          const redirectUrl = `${loginUrl}?redirect_uri=${encodeURIComponent(window.location.origin + '/#/auth/' + this.$route.name)}`;
          window.open(redirectUrl, "_parent");
        })
        .catch(() => {});
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.aside-top {
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  min-height: 50px;
  max-height: 50px;
  background: #fff;
  color: #333;
  font-size: 14px;
  flex-shrink: 0;

  .title {
    margin-left: 15px;
    font-size: 18px;
  }

  .nameMes {
    display: flex;
    align-items: center;

    .name {
      margin-right: 10px;
      font-size: 16px;
    }

    .icon {
      cursor: pointer;
    }

    .sign-out {
      padding-left: 22px;
      background: url("../../../../public/images/sign-out.png") left center
        no-repeat;
      background-size: 16px;
      cursor: pointer;

      &:hover {
        color: #1f2e54;
      }
    }
  }
}
</style>
